module.exports = __webpack_public_path__ + "static/img/texasAustin.5f293e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/texasAustin.svg
// module id = Kb9C
// module chunks = 1